import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Table, Button, Modal, Form, Input, ModalHeader, ModalBody, ModalFooter, Row, Col, Card, CardBody, Container, FormGroup, Label, FormFeedback } from 'reactstrap';
import { FaPlus, FaEdit, FaTrash, FaRegBuilding, FaCubes } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { categoryActions } from '../../sagas/categorySlice';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Swal from 'sweetalert2';

const CategorieList = () => {
    const dispatch = useDispatch();
    const categories = useSelector((state) => state.categories.list); // Adjust state path as needed
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [editingCategory, setEditingCategory] = useState(null);
    const [name, setName] = useState('');
    const { t } = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(categoryActions.list()); // Fetch categories on component mount
    }, [dispatch]);

    useEffect(() => {

    }, [categories]);


    const handleCloseModal = () => {
        setIsModalVisible(false);
        formik.resetForm();
        dispatch(categoryActions.list()); // Fetch categories on component mount
    };

    const toggleModal = () => {
        setIsModalVisible(!isModalVisible);
        setEditingCategory(null);
        setName('');
    };


    const handleEditCategory = (category) => {
        setEditingCategory(category);
        setName(category.name);
        setIsModalVisible(true);
    };

    const handleUpdateCategory = () => {
        if (editingCategory) {
            dispatch(categoryActions.update({ id: editingCategory.id, category: { name } }));
            toggleModal();
        }
    };

    const formik = useFormik({
        initialValues: {
            code: '',
            libelle: '',
        },
        validationSchema: Yup.object({
            libelle: Yup.string().required('Libelle is required'),
        }),
        onSubmit: (values) => {
            let payload = {
                data:{
                    code: values.code,
                    libelle: values.libelle,
                },
                onSuccess: () => {
                    Swal.fire({
                                        icon: 'success',
                                        title: 'Succès',
                                        text: 'Catégorie enregistrés avec succès!',
                                        confirmButtonText: 'OK',
                                    });
                    handleCloseModal();
                }
            }
            dispatch(categoryActions.create(payload));
        },
    });


    const handleAddCategory = () => {
        formik.handleSubmit();
    }

    const handleDeleteCategory = (id) => {
        dispatch(categoryActions.delete(id));
    };

    return (
        <Container fluid>
            <Row className="mb-4" >
                <Col>
                    <Card className="shadow-sm">
                        <CardBody className="d-flex justify-content-between align-items-center">
                            <h4 className="mb-0 d-flex align-items-center">
                                <FaCubes className="text-primary me-2" />
                                {t('category.list')}
                            </h4>
                            <Button
                                color="primary"
                                onClick={() => toggleModal()} // Go back to the previous page
                                className="d-flex align-items-center"
                            >
                                <FaPlus className="me-2" />
                                {t('category.new')}
                            </Button>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Card className="shadow-sm">
                <CardBody>
                <div className="table-responsive" style={{ maxHeight: '500px', overflowY: 'auto' }}>

                    <Table bordered>
                        <thead>
                            <tr>
                                <th>{t('category.code')}</th>
                                <th>{t('category.label')}</th>
                                <th>{t('common.actions')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {categories.length > 0 && categories.map((category) => (
                                <tr key={category.id}>
                                    <td>{category.code}</td>
                                    <td>{category.libelle}</td>
                                    <td>
                                        <Button
                                            color="warning"
                                            size="sm"
                                            onClick={() => handleEditCategory(category)}
                                        >
                                            <FaEdit />
                                        </Button>{' '}
                                        <Button
                                            color="danger"
                                            size="sm"
                                            onClick={() => handleDeleteCategory(category.id)}
                                        >
                                            <FaTrash /> 
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                    </div>
                    {categories.length === 0 && (
                        <div className="text-center mt-4">
                            <FaCubes size={50} className="text-muted" />
                            <h5 className="mt-2">{t('category.noCategories')}</h5>
                        </div>
                    )}

                </CardBody>
            </Card>
            <Modal isOpen={isModalVisible} toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}>
                    {editingCategory ? t('category.edit') : t('category.new')}
                </ModalHeader>
                <ModalBody>
                    <Form onSubmit={formik.handleSubmit}>
                        
                        <FormGroup>
                            <Label for="libelle">{t('category.label')}</Label>
                            <Input
                                type="text"
                                name="libelle"
                                id="libelle"
                                value={formik.values.libelle}
                                onChange={formik.handleChange}
                                invalid={formik.touched.libelle && Boolean(formik.errors.libelle)}
                            />
                            <FormFeedback>{formik.errors.libelle}</FormFeedback>
                        </FormGroup>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleAddCategory}>
                        {editingCategory ? t('common.update') : t('common.save')}
                    </Button>{' '}
                    <Button color="secondary" onClick={toggleModal}>
                        {t('common.cancel')}
                    </Button>
                </ModalFooter>
            </Modal>
        </Container>
    );
};

export default CategorieList;